import React, { useState, useEffect } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const PaymentMethods = () => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [BreadcrumList, setBreadcrumList] = useState([]);

  const fetchBreadcrumImageData = async () => {
    try {
      const response = await corefetch(
        "Breadcrum/GetBreadcrumDetailsByCategory?CategoryCode=PAYMETHOD"
      );
      if (response && response.length > 0) {
        console.log("fxftyxfyt:", response);
        setBreadcrumList(response);
      } else {
        setBreadcrumList([]);
        console.log("No Breadcrum found");
      }
    } catch (error) {
      console.error("Error fetching Breadcrum List:", error);
      setBreadcrumList([]);
    }
  };

  const fetchData = async () => {
    try {
      const list = await corefetch(`PaymentMethod/GetPaymentMethods`);
      setPaymentMethods(list || []);
    } catch (error) {
      setPaymentMethods([]);
      console.error("Error fetching payment methods:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchBreadcrumImageData();
  }, []);

  useEffect(() => {
    if (paymentMethods && paymentMethods.length) {
      setTimeout(function () {
        if ($(".fancybox").length) {
          $(".fancybox").fancybox({
            openEffect: "elastic",
            closeEffect: "elastic",
            wrapCSS: "project-fancybox-title-style",
          });
        }
      }, 400);
    }
  }, [JSON.stringify(paymentMethods)]);

  const backgroundImageStyle = BreadcrumList[0]
    ? {
        backgroundImage: `url(${ImageURL}${BreadcrumList[0].imagePath})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : {};

  return (
    <>
      <section className="wpo-page-title" style={backgroundImageStyle}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <div className="wpo-breadcumb-wrap">
                <h2>Payment Methods</h2>
                <ol className="wpo-breadcumb-wrap">
                  <li>
                    <a href="/home">Home</a>
                  </li>
                  <li>Payment Methods</li>
                </ol>
              </div>
            </div>
          </div>{" "}
        </div>{" "}
      </section>
      <section className="section-padding pb-0" id="payment-methods">
        <div className="container">
          {paymentMethods.length > 0 && (
            <>
              <div className="payment-accordion">
                {paymentMethods.slice(0, 2).map((method) => (
                  <details
                    style={{}}
                    key={method.paymentMethodID}
                    className="payment-details"
                  >
                    <summary
                      className="summary-text"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",

                        cursor: "pointer",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ flexGrow: 1, textAlign: "center" }}>
                        {method.paymentMethod}
                      </span>
                      <div
                        className="control-icons"
                        style={{ display: "flex", gap: "10px" }}
                      >
                        <div className="control-icon control-icon-expand">
                          <i
                            style={{ fontSize: "20px" }}
                            className="fa fa-angle-down"
                          ></i>
                        </div>
                        <div className="control-icon control-icon-close">
                          <i
                            style={{ fontSize: "20px" }}
                            className="fa fa-angle-up"
                          ></i>
                        </div>
                      </div>
                    </summary>
                    <div
                      className="payment-method-details"
                      style={{ padding: "5px" }}
                    >
                      {/* Image */}
                      {method.sampleImage && (
                        <div
                          onClick={(e) => e.stopPropagation()} // Prevent closing the <details> tag
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginBottom: "15px",
                          }}
                        >
                          <a
                            href={method.sampleImage}
                            // href={method.sampleImage}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="fancybox"
                            data-fancybox-group="gall-1"
                            style={{
                              display: "block",
                              position: "relative",
                            }}
                          >
                            <img
                              src={method.sampleImage}
                              // src="${ImageURL}${method.sampleImage}"
                              alt={method.paymentMethod}
                              className="img img-responsive"
                              style={{
                                width: "120px",
                                height: "120px",
                                objectFit: "cover",
                                borderRadius: "10px",
                                transition: "transform 0.3s ease",
                              }}
                            />
                          </a>
                        </div>
                      )}

                      {method.paymentMethodLink && (
                        <div
                          style={{
                            marginBottom: "10px",
                            textAlign: "center",
                          }}
                        >
                          <h5
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#1f2937",
                              marginBottom: "5px",
                            }}
                          >
                            {["Credit Card", "Debit Card"].includes(
                              method.paymentMethod
                            )
                              ? "Payment Link"
                              : "Payment Id"}
                          </h5>
                          <p style={{ color: "black", fontWeight: "500" }}>
                            {method.paymentMethodLink}
                          </p>
                        </div>
                      )}

                      {/* Details */}
                      <div style={{ marginTop: "20px", textAlign: "center" }}>
                        {method.bankName && (
                          <p style={{ margin: "5px 0" }}>
                            <strong>Bank:</strong> {method.bankName}
                          </p>
                        )}
                        {method.accountNumber && (
                          <p style={{ margin: "5px 0" }}>
                            <strong>Account No:</strong> {method.accountNumber}
                          </p>
                        )}
                        {method.wireRoutingNo && (
                          <p style={{ margin: "5px 0" }}>
                            <strong>Routing No:</strong> {method.wireRoutingNo}
                          </p>
                        )}
                      </div>
                    </div>
                  </details>
                ))}
              </div>

              {paymentMethods.length > 2 && (
                <>
                  <div className="wpo-section-title">
                    <h4 style={{ fontSize: "26px" }}>Other Payment Methods</h4>
                  </div>
                  <div className="payment-accordion">
                    {paymentMethods.slice(2).map((method) => {
                      const hasRelevantData =
                        method.sampleImage ||
                        method.paymentMethodLink ||
                        method.bankName ||
                        method.accountNumber ||
                        method.wireRoutingNo;

                      // Only render the details if there is relevant data
                      return hasRelevantData ? (
                        <details
                          key={method.paymentMethodID}
                          className="payment-details"
                        >
                          <summary
                            className="summary-text"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",

                              cursor: "pointer",
                              textAlign: "center",
                            }}
                          >
                            <span style={{ flexGrow: 1, textAlign: "center" }}>
                              {method.paymentMethod}
                            </span>
                            <div
                              className="control-icons"
                              style={{ display: "flex", gap: "10px" }}
                            >
                              <div className="control-icon control-icon-expand">
                                <i
                                  style={{ fontSize: "20px" }}
                                  className="fa fa-angle-down"
                                ></i>
                              </div>
                              <div className="control-icon control-icon-close">
                                <i
                                  style={{ fontSize: "20px" }}
                                  className="fa fa-angle-up"
                                ></i>
                              </div>
                            </div>
                          </summary>
                          <div
                            className="payment-method-details"
                            style={{ padding: "5px" }}
                          >
                            {/* Image */}
                            {method.sampleImage && (
                              <div
                                onClick={(e) => e.stopPropagation()} // Prevent closing the <details> tag
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  marginBottom: "15px",
                                }}
                              >
                                <a
                                  href={method.sampleImage}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="fancybox"
                                  data-fancybox-group="gall-1"
                                  style={{
                                    display: "block",
                                    position: "relative",
                                  }}
                                >
                                  <img
                                    src={method.sampleImage}
                                    alt={method.paymentMethod}
                                    className="img img-responsive"
                                    style={{
                                      width: "120px",
                                      height: "120px",
                                      objectFit: "cover",
                                      borderRadius: "10px",
                                      transition: "transform 0.3s ease",
                                    }}
                                  />
                                </a>
                              </div>
                            )}

                            {/* Payment Link */}
                            {method.paymentMethodLink && (
                              <div
                                style={{
                                  marginBottom: "10px",
                                  textAlign: "center",
                                }}
                              >
                                <h5
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    color: "#1f2937",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {["Credit Card", "Debit Card"].includes(
                                    method.paymentMethod
                                  )
                                    ? "Payment Link"
                                    : "Payment Id"}
                                </h5>
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                >
                                  {method.paymentMethodLink}
                                </p>
                              </div>
                            )}

                            {/* Details */}
                            <div
                              style={{ marginTop: "20px", textAlign: "center" }}
                            >
                              {method.paymentAddress && (
                                <p style={{ margin: "5px 0" }}>
                                  <strong>Address:</strong>{" "}
                                  {method.paymentAddress}
                                </p>
                              )}
                              {method.bankName && (
                                <p style={{ margin: "5px 0" }}>
                                  <strong>Bank:</strong> {method.bankName}
                                </p>
                              )}
                              {method.accountNumber && (
                                <p style={{ margin: "5px 0" }}>
                                  <strong>Account No:</strong>{" "}
                                  {method.accountNumber}
                                </p>
                              )}
                              {method.wireRoutingNo && (
                                <p style={{ margin: "5px 0" }}>
                                  <strong>Routing No:</strong>{" "}
                                  {method.wireRoutingNo}
                                </p>
                              )}
                            </div>
                          </div>
                        </details>
                      ) : null; // Don't render the div if no relevant data exists
                    })}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default PaymentMethods;
